import { Object3D } from "three";
import { BatchedRenderer, QuarksUtil } from "three.quarks";
import { GameResourcesPackage } from "../../../../resources/GameResourcesPackage";
import { clone } from "three/examples/jsm/utils/SkeletonUtils.js";

export class BoxLandingParticle extends Object3D {

    public constructor(
        private readonly gameResources: GameResourcesPackage,
        private readonly batchRenderer: BatchedRenderer
    ) {
        super();
    }

    public async play(): Promise<void> {
        const effect = clone(this.gameResources.assets_game_particles_box_landing_thjson);
        QuarksUtil.setAutoDestroy(effect, true);
        QuarksUtil.addToBatchRenderer(effect, this.batchRenderer);
        QuarksUtil.play(effect);
        this.add(effect);
    }
}
